import styled from "styled-components";
import { useEffect, useState } from "react";
import GreenIsotype from "../../assets/img/GreenIsotype.png";
import { useNavigate } from "react-router";
import SuperverseLogo from "../../assets/svg/superverseLogo";

const StyledRentCard = styled.div`
    width: 265px;
    height: 388px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 25px;

    .loading-widget {
        width: 265px;
        height: 388px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px 20px 50px 20px;
        object-fit: cover;
    }

    .blurred-container {
        background-color: #38EF7D;
        width: 153px;
        height: 81px;
        filter: blur(1.9rem);        
        margin-bottom: 100px;
        position: absolute;
        z-index: -1;
    }

    img {
        width: 264px;
        height: 264px;
        border-radius: 40px;
        object-fit: cover;
        border-width: 0px !important;
        border-color: transparent !important;
        border-style: solid !important;        
    }

    .card-title {
        width: 100%;
        display: flex;
        justify-content: start;
        align-items: center;
        font-size: 20px;
        line-height: 24px;
        font-weight: 400;
        color: #FFFFFF;
        font-family: 'exo', sans-serif;
    }

    .tags {
        display: flex;
        justify-content: start;
        align-items: center;
        width: 100%;
    }

    .status {
        width: 93px;
        height: 29px;
        border-radius: 20px;
        background: #FFFFFF0D; 
        color: #A6A6A6;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        margin-right: 10px;
        border-width: 0.4px;
        border-style: solid;
        border-color: #FFFFFF1A;
    }

    .price {
        padding: 0px 10px 0px 10px;
        height: 29px;
        border-radius: 20px;
        background: #38EF7D; 
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;        

        p {
            color: #000000;
            font-size: 15px;
            font-weight: 400;
            line-height: 18px;
            margin: 0px;
            text-align: center;
            font-family: 'exo', sans-serif !important;
        }
    }

    .glowing-light {
        height: 40px;
        width: 200px;
        background: #38EF7D;
        position: absolute;
        bottom: 130px;
        z-index: -1;
        filter: blur(3rem);       
    }
`;

export default function RentCard({ rentItem }) {

    const navigate = useNavigate();

    const zkevmCollections = {
        "0x7a6d3fb14a2eefd8173584a96abd2fafa08e396a": 'pet', //Pets
        "0x2bcbb73c73d765a695f972bdd84222ee8ee55f2d": 'qorb', //Qorb
        "0xcd05e79857c1c0eb1eeaf1573a12c25d411e0757": 'pass', //qorX
        "0xb1dbf0fc711f268b3a3755f8171a9269d6d105fd": 'skin', //Skins
    };
    
    const [asset, setAsset] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        console.log(rentItem);
        async function loadAssetData() {
            setIsLoading(true);
            try {
                const collectionType = zkevmCollections[rentItem.nftData.contractAddress.toLowerCase()];
                if (collectionType) {
                    const metadataResponse = await fetch(`https://assets.qorbiworld.com/resource/${collectionType}/${rentItem.nftData.tokenId}`);
                    const result = await metadataResponse.json();
                    setAsset(result);
                }
            } catch (error) {
                console.error("Failed to fetch asset metadata", error);
            }
            setIsLoading(false);
        }
        loadAssetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rentItem]);

    function onTap() {
        navigate(`/rentals/${rentItem.nftData.tokenId}/${rentItem.nftData.contractAddress}`);
    }

    return (
        <StyledRentCard onClick={onTap}>
            {
                isLoading ?
                    <div className="loading-widget">
                        <img alt="Green Isotype" src={GreenIsotype} />
                    </div>
                    :
                    <>
                        <div className="glowing-light"></div>
                        <img alt={asset?.name || "Asset Image"} src={asset?.image} />
                        <div className="card-title">
                            {asset?.name} (Rent)
                        </div>
                        <div className="tags">
                            {/* <div className="status">{rentItem.status}</div> */}
                            <div className="price">
                                {
                                    (rentItem.currency ?? "QORBI") === "QORBI" ?
                                        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.507 13.0089C15.3319 11.8301 15.8177 10.4476 15.9114 9.0119C16.0051 7.5762 15.7032 6.14229 15.0385 4.86627C14.3738 3.59024 13.3719 2.52099 12.1417 1.77489C10.9115 1.0288 9.50018 0.634449 8.06142 0.634769C7.70573 0.634432 7.35043 0.658548 6.99805 0.706947V2.41868C7.40152 2.3368 7.81212 2.29512 8.22383 2.29424C9.48644 2.2932 10.7189 2.68019 11.7543 3.40279C12.7897 4.1254 13.578 5.14872 14.0126 6.33421C14.4471 7.5197 14.5069 8.81008 14.1837 10.0307C13.8606 11.2512 13.1702 12.343 12.206 13.1582L13.0852 14.0486L13.3509 14.3181L15.1684 16.1611H17.8023L14.5045 13.007L14.507 13.0089Z" fill="#000000" />
                                            <path d="M11.4964 13.682C10.1674 14.5266 8.56547 14.8301 7.01965 14.5303C5.47383 14.2305 4.10151 13.3501 3.18459 12.07C2.26768 10.7899 1.87579 9.20727 2.08944 7.64721C2.30308 6.08715 3.10604 4.66813 4.33336 3.68166L4.35327 8.52131C4.35327 9.53736 4.75689 10.5118 5.47535 11.2303C6.19381 11.9487 7.16824 12.3523 8.18429 12.3523C8.69144 12.3571 9.19449 12.2611 9.66427 12.07C10.134 11.8788 10.5612 11.5963 10.921 11.2389C11.2807 10.8814 11.5659 10.456 11.7601 9.98748C11.9542 9.51894 12.0534 9.01651 12.0519 8.50934C12.0503 8.00217 11.9481 7.50035 11.7512 7.03298C11.5543 6.56561 11.2665 6.14198 10.9046 5.78667C10.5427 5.43136 10.1138 5.15143 9.64291 4.96312C9.172 4.77481 8.66838 4.68186 8.16127 4.68966C7.75535 4.6915 7.3523 4.75787 6.96723 4.88628V6.76851C7.35002 6.4806 7.81864 6.33005 8.29749 6.34113C8.77634 6.35221 9.23749 6.52428 9.60656 6.82958C9.97563 7.13488 10.2311 7.5556 10.3317 8.02389C10.4324 8.49217 10.3723 8.98071 10.1613 9.41068C9.95023 9.84066 9.60049 10.187 9.16847 10.3938C8.73645 10.6007 8.24736 10.6559 7.78008 10.5507C7.3128 10.4455 6.89459 10.186 6.59291 9.81393C6.29123 9.4419 6.12367 8.97909 6.11727 8.50015L6.10296 5.30442L6.11727 2.66184V0.87793C4.26019 1.3515 2.6399 2.48682 1.56075 4.07064C0.481606 5.65445 0.017853 7.57779 0.256602 9.47937C0.495351 11.381 1.42017 13.13 2.85736 14.3978C4.29454 15.6657 6.1452 16.3653 8.06171 16.365C8.15069 16.365 8.23967 16.365 8.32678 16.3601V16.365L14.0232 16.1628L12.6543 14.8854L11.4958 13.6826L11.4964 13.682Z" fill="#000000" />
                                        </svg>
                                        :
                                        <SuperverseLogo width={20} height={20}></SuperverseLogo>
                                }
                                <div style={{ width: 5 }}></div>
                                <p>${parseFloat(rentItem.matchPrice).toFixed(2)} Per Match</p>
                            </div>
                        </div>
                    </>
            }
        </StyledRentCard>
    );
}
